import React, { useState, useEffect } from 'react';
import { MdFileDownload } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { ListPropertiesRequest } from '~/store/modules/properties/actions';
import { Container, CardContainer, Loader, Info } from './styles';
import history from '~/services/history';

import api from '~/services/apiBearer';
import { store } from '~/store';

import refera from '~/util/refera';

export default function Property(props) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(
    useSelector(state => state.properties.loading)
  );
  const [address, setAddress] = useState('');
  const [contractId, setContractId] = useState(0);
  const [franquia, setFranquia] = useState(0);
  const [businessId, setBusinessId] = useState(0);
  const [reference, setReference] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const property = useSelector(state => state.property.property);
  const [hasInspection, setHasInspection] = useState(0);
  const _state = useSelector(state => state);

  useEffect(() => {
    const {
      sAddress,
      sContractId,
      sReference,
      sStatus,
      sBusinessId,
      sEmail,
      SFranquia,
    } = props.location.state;


    refera.init(_state)

    setAddress(sAddress);
    setContractId(sContractId);
    setFranquia(SFranquia);
    setReference(sReference);
    setStatus(sStatus);
    setBusinessId(sBusinessId);
    setEmail(sEmail);

    

    setTimeout(()=>{
      handleDownloadInspectionReport(true, sContractId, sReference)
    },1000)

  }, [props]);

  useEffect(() => {
    if (
      !props.location?.state?.reference ||
      !props.location?.state?.address ||
      !props.location?.state?.businessId
    ) {
      setReference(property.reference);
      setAddress(property.address);
      setBusinessId(property.businessId);
      setStatus(property.status);
    }
  }, [property]);

  useEffect(() => {
    const { token } = store.getState().auth;
    dispatch(ListPropertiesRequest(token));
  }, [dispatch]);

  function handleOpenFAQ(title, topicId) {
    history.push({
      pathname: '/FAQ',
      state: {
        sContractId: contractId,
        sReference: reference,
        sAddress: address,
        sTopic: title,
        sTopicId: topicId,
      },
    });
  }

  function handleDownloadContract() {
    setLoader(true);

    let logged_user = store.getState().user
    let property_ref = property.reference
    let user_doc = logged_user.profile.documento
    let key_check = `${user_doc}_${property_ref}`

    let custom_file = null
    switch (key_check) {
      case  '07066932994_103090':
        custom_file = 'https://s3.us-west-1.amazonaws.com/apolar.openfiles/contratos/07066932994/103090.pdf'
        break;
      case  '07066932994_106595':
        custom_file = 'https://s3.us-west-1.amazonaws.com/apolar.openfiles/contratos/07066932994/106595.pdf'
        break;
    
      default:
        break;
    }

    if (custom_file) {
      setLoader(false);
      window.open(custom_file)
      return false
    }

    const url =
      contractId > 0
        ? `api/v1/WSContrato?Contrato=${contractId}`
        : `api/v1/WSContratoProprietario?referencia=${reference}`;

    api
      .get(url)
      .then(
        response => {
          const {
            sucesso: success,
            mensagem: message,
            conteudo: responseUrl,
          } = response.data;

          if (success) {
            if (businessId > 0)
              //window.open(responseUrl[responseUrl.length - 1]);
              window.open(responseUrl[0])//ajustado para retornar o primeiro registro não o ultimo
            else window.open(responseUrl);
          } else toast.error(message);
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }

  function handleDownloadInspectionReport(check, contractIdParam, referenceParam) {
    setLoader(true);


    let logged_user = store.getState().user
    let property_ref = property.reference
    let user_doc = logged_user.profile.documento
    let key_check = `${user_doc}_${property_ref}`

    let custom_file = null
    switch (key_check) {
      case  '07066932994_103090':
        custom_file = 'https://s3.us-west-1.amazonaws.com/apolar.openfiles/vistorias/07066932994/103090.pdf'
        break;
      case  '07066932994_106595':
        custom_file = 'https://s3.us-west-1.amazonaws.com/apolar.openfiles/vistorias/07066932994/106595.pdf'
        break;
    
      default:
        break;
    }

    if (custom_file) {
      setLoader(false);

      if (!check) {
        window.open(custom_file)
      }
      setHasInspection(1)
      return true
    }

    const url =
      contractIdParam > 0
        ? `api/v1/WSVistoria?Contrato=${contractIdParam}`
        : `api/v1/WSVistoriaProprietario?referencia=${referenceParam}`;

    api
      .get(url)
      .then(
        response => {
          const {
            sucesso: success,
            mensagem: message,
            conteudo: responseUrl,
          } = response.data;

          if (success) {
            if (check) {
              setHasInspection(1)
            } else {
              window.open(responseUrl[0].link);
            }
           
          } else {
            if (!check) {
              toast.error(message)
            }
          }
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }

  function handleToNavigateSecondBillet() {
    history.push({
      pathname: '/SegundaViaBoleto',
      state: {
        sContractId: contractId,
        sReference: reference,
        sAddress: address,
        sStatus: status === 'Ativo',
      },
    });
  }

  function handleOpenReservationFund(title) {
    history.push({
      pathname: '/FundoDeReserva',
      state: {
        sContractId: contractId,
        sReference: reference,
        sAddress: address,
        sStatus: status === 'Ativo',
        sTopic: title,
      },
    });
  }

  function handleOpenRepairRequest(title) {

    refera.open(property)
    return false

    window.open("https://admin.refera.com.br/solicitar-manutencao/apolar", '_blank').focus();
    return false
    
    history.push({
      pathname: '/SolicitarReparo',
      state: {
        sContractId: contractId,
        sReference: reference,
        sAddress: address,
        sTopic: title,
        SFranquia: franquia
      },
    });
  }

  // eslint-disable-next-line no-unused-vars
  function handleOpenFinancialSummary(title) {
    history.push({
      pathname: '/ResumoFinanceiro',
      state: {
        sContractId: contractId,
        sReference: reference,
        sAddress: address,
        sTopic: title,
      },
    });
  }

  function handleOpenStatement() {
    history.push({
      pathname: '/Extrato',
      state: {
        sBusinessId: businessId,
        sReference: reference,
        sAddress: address,
      },
    });
  }

  function handleOpenCalendary(title) {
    history.push({
      pathname: '/Calendario',
      state: {
        sBusinessId: businessId,
        sReference: reference,
        sAddress: address,
        sTopic: title,
      },
    });
  }
  function handleOpenMyAds(title) {
    history.push({
      pathname: '/MeusAnuncios',
      state: {
        sBusinessId: businessId,
        sReference: reference,
        sAddress: address,
        sEmail: email,
        sTopic: title,
      },
    });
  }

  function handleOpenIncomeTax(title) {
    history.push({
      pathname: '/ImpostoDeRenda',
      state: {
        sBusinessId: businessId,
        sReference: reference,
        sAddress: address,
        sEmail: email,
        sTopic: title,
      },
    });
  }

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />
      <Info statusColor={status === 'Ativo' ? '#66CC00' : '#CC0000'}>
        <h3>Ref.: {reference}</h3>
        <h3>Contrato: {contractId > 0 ? contractId : businessId}</h3>
        <h3>{address}</h3>
        {contractId > 0 ? (
          <h3 className="status">Aluguel {status}</h3>
        ) : (
          <h3>Status do imóvel: {status}</h3>
        )}
      </Info>
      {contractId > 0 ? (
        <CardContainer>
          <h3>ACESSO RÁPIDO</h3>
          <div>
            <button
              type="button"
              onClick={() =>
                handleToNavigateSecondBillet(
                  contractId,
                  reference,
                  address,
                  status
                )
              }
            >
              2ª via de boleto
            </button>
            <button
              type="button"
              onClick={() => handleOpenReservationFund('Fundo de Reserva')}
            >
              Fundo de reserva
            </button>
            <button
              type="button"
              style={{ display: status === 'Ativo' ? 'flex' : 'none' }}
              onClick={() => handleOpenRepairRequest('Solicitar um reparo')}
            >
              Solicitação de reparos
            </button>
          </div>
        </CardContainer>
      ) : (
        <CardContainer>
          <h3>ACESSO RÁPIDO</h3>
          <div>
            <button type="button" onClick={() => handleOpenStatement()}>
              Extrato
            </button>
            <button
              type="button"
              onClick={() => handleOpenCalendary('Calendário de repasse')}
            >
              Calendário de repasse
            </button>
            <button
              type="button"
              onClick={() => handleOpenMyAds('Meus anúncios')}
            >
              Meus anúncios
            </button>
            <button
              type="button"
              onClick={() => handleOpenIncomeTax('Imposto de renda')}
            >
              Imposto de renda
            </button>
          </div>
        </CardContainer>
      )}

      <CardContainer>
        <h3>SOBRE A LOCAÇÃO</h3>
        <div>
          <button
            type="button"
            onClick={() => handleOpenFAQ('Entrada no Imóvel', 1)}
          >
            Entrada no imóvel
          </button>
          <button
            type="button"
            onClick={() => handleOpenFAQ('Durante a Locação', 2)}
          >
            Durante a locação
          </button>
          <button
            type="button"
            onClick={() => handleOpenFAQ('Pagamento e Taxas', 3)}
          >
            Pagamentos e taxas
          </button>
          <button
            type="button"
            onClick={() => handleOpenFAQ('Saída do Imóvel', 4)}
          >
            Saída do imóvel
          </button>
        </div>
      </CardContainer>

      <CardContainer>
        <h3>SOBRE MEU CONTRATO</h3>
        <div className="myContract">
          <button type="button" onClick={() => handleDownloadContract()}>
            <MdFileDownload size={20} />
            BAIXE SEU CONTRATO
          </button>
          
          {hasInspection ? (
            <button
              type="button"
              onClick={() => handleDownloadInspectionReport(false, contractId, reference)}
            >
              <MdFileDownload size={20} />
              LAUDO DE VISTORIA DE ENTRADA
            </button>
          ) : (
            <></>
          )}
          
        </div>
      </CardContainer>
    </Container>
  );
}

Property.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
